import React, { useState } from 'react';
import { Card, CardBody } from '../common';
import { StoryViewer } from './StoryViewer';
import { useAllPassages } from '../../hooks/usePassages';

export const CollapsibleStoryViewer = ({ gameId }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { data, isLoading } = useAllPassages(gameId);

  const passageCount = data?.passages?.length || 0;

  // Don't show if no passages
  if (!isLoading && passageCount === 0) {
    return null;
  }

  return (
    <div className="mt-8">
      <Card>
        <button
          className="w-full text-left"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <div className="px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors">
            <div className="flex items-center gap-3">
              <svg
                className="w-5 h-5 text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                />
              </svg>
              <span className="font-semibold">
                View Story
                {isLoading ? (
                  <span className="ml-2 text-gray-400">...</span>
                ) : (
                  <span className="ml-2 text-gray-500 font-normal">
                    ({passageCount} passage{passageCount !== 1 ? 's' : ''})
                  </span>
                )}
              </span>
            </div>
            <svg
              className={`w-5 h-5 text-gray-400 transition-transform ${isExpanded ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </button>

        {isExpanded && (
          <div className="border-t">
            <CardBody>
              <StoryViewer gameId={gameId} />
            </CardBody>
          </div>
        )}
      </Card>
    </div>
  );
};
